

export const hermioneReviewerReviewHinge = {
  _id: 'hermioneReviewerReviewHingeId',
  email: 'hermione@email.com',
  profileReviewId: 'hermioneProfileReviewHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Hermione! This will really help me!',
  profileReviewedFirstName: 'Harry',
}

export const dumbledoreReviewerReviewBumble = {
  _id: 'dumbledoreReviewerReviewBumbleId',
  email: 'dumbledore@email.com',
  profileReviewId: 'dumbledoreProfileReviewBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Dumbledore! This will really help me!',
  profileReviewedFirstName: 'Harry',
}

export const ronReviewerReviewTinder = {
  _id: 'ronReviewerReviewTinderId',
  email: 'ron@email.com',
  profileReviewId: 'ronProfileReviewTinderId',
  reviewerProfileId: 'ronReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ron! This will really help me!',
  profileReviewedFirstName: 'Harry',
}